export const detectAdBlock = () => {
    return new Promise((resolve) => {
        if (!document.body) {
            setTimeout(() => detectAdBlock().then(resolve), 50);
            return;
        }

        const testScript = document.createElement("script");
        testScript.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
        testScript.async = true;

        testScript.onload = () => {
            // Skript konnte geladen werden -> kein AdBlock
            cleanup();
            resolve(false);
        };

        testScript.onerror = () => {
            // Skript konnte NICHT geladen werden -> AdBlock erkannt
            cleanup();
            resolve(true);
        };

        const cleanup = () => {
            if (testScript.parentNode) {
                testScript.parentNode.removeChild(testScript);
            }
        };

        document.body.appendChild(testScript);
    });
};
